export default {
    data: () => ({
        translations: {
            title: {
                el: "Πόντοι ανά Προϊόν",
                en: "Product Points",
                it: "Punti Prodotto"
            },
            info: {
                el: "Καθορίστε τον αριθμό των πόντων που μπορούν να κερδίσουν οι πελάτες σας ανά προϊόν, καθώς και τον τρόπο ανταμοιβής πόντων. Μπορείτε επίσης να επιλέξετε για ποια προϊόντα να επιδοτούνται οι πόντοι (η επιδότηση σημαίνει ότι η μητρική σας εταιρεία θα καλύψει το κόστος χορήγησης πόντων στους πελάτες σας).",
                en: `
                    Specify the number of points that can be won per product. You can also choose whether you want these points to be subsidized or not (subsidized points mean that your parent company will cover the cost of granting points to your customers).
                `,
                it: "Specificare il numero di punti che possono essere vinti per prodotto. Puoi anche scegliere se vuoi che questi punti siano sovvenzionati o meno (i punti sovvenzionati significano che la tua società madre coprirà il costo della concessione dei punti ai tuoi clienti)."
            },
            productName: {
                el: "Όνομα Προϊόντος",
                en: "Product Name",
                it: "Nome del Prodotto"
            },
            points: {
                el: "Πόντοι",
                en: "Points",
                it: "Punti"
            },
            type: {
                el: "Τύπος",
                en: "Type",
                it: "Tipo"
            },
            pointSubsidy: {
                el: "Επιδότηση",
                en: "Subsidy",
                it: "Sussidio"
            },
            action: {
                el: "Ενέργειες",
                en: "Action",
                it: "Azione"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            subsidizedPoints: {
                el: "Με Επιδότηση",
                en: "Subsidized Points",
                it: "Con sussidio"
            },
            change: {
                el: "Αλλαγή",
                en: "Change",
                it: "Cambia"
            },
            perTransaction: {
                el: "Ανά Συναλλαγή",
                en: "Per Transaction",
                it: "Per transazione"
            },
            perEuro: {
                el: "Ανά Ευρω",
                en: "Per Euro",
                it: "Per Euro"
            },
            piece: {
                el: "Ανά Τεμάχιο",
                en: "Per Piece",
                it: "Per pezzo"
            },
            liters: {
                el: "Ανά Λίτρο",
                en: "Per Liters",
                it: "Per litro"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
